import React from "react";
import Icon from "@ant-design/icons";

const EllipseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 11.2v-4"
    ></path>
    <circle cx="8" cy="8.002" r="6.4" stroke="currentColor"></circle>
    <path fill="currentColor" d="M8.4 5.2a.4.4 0 11-.8 0 .4.4 0 01.8 0z"></path>
  </svg>
);

const EllipseIcon = (props) => {
  return <Icon component={EllipseSvg} {...props} />;
};

export { EllipseIcon };
